import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewAllowanceModal from 'modules/timeoff/components/TimeoffAllowances/UpsertAllowance/NewAllowanceModal'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

type NewAllowanceModalProps = React.ComponentProps<typeof NewAllowanceModal>

const AddAllowanceModalPage = () => {
  const { navigation } = useNavigation()

  const { policy } = useOutletContext<RouteContextParams>()
  const policyId = policy?.attributes.id
  const navigate = useNavigate()

  const onClose: NewAllowanceModalProps['onClose'] = () => {
    navigate(navigation.settings.timeoffPolicies.id.details.fullPath({ id: policyId }))
  }

  const onSubmit: NewAllowanceModalProps['onSubmit'] = (payload) => {
    navigate(navigation.settings.timeoffPolicies.id.allowances.new.fullPath({ id: policyId }), {
      state: payload,
    })
  }

  return <NewAllowanceModal onClose={onClose} onSubmit={onSubmit} />
}

export default AddAllowanceModalPage
